export const ReportTypeEnum = {
  FRV: 'FRV',
  FMV: 'FMV',
  ALL: 'ALL',
}

export const renderReportTypeColor = {
  FRV: {
    color: '#5925DC',
    backgroundColor: '#F4F3FF',
  },
  FMV: {
    color: '#175CD3',
    backgroundColor: '#EFF8FF',
  },
  ALL: {
    color: '#027A48',
    backgroundColor: '#ECFDF3',
  },
};
